"use strict";exports.__esModule=true;exports.default=void 0;var formatGroup=function formatGroup(grouping,thousands){return function(value,width){var i=value.length,t=[],j=0,g=grouping[0],length=0;while(i>0&&g>0){if(length+g+1>width)g=Math.max(1,width-length);t.push(value.substring(i-=g,i+g));if((length+=g+1)>width)break;g=grouping[j=(j+1)%grouping.length]}return t.reverse().join(thousands)}};var _default=formatGroup;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/number-converter/format-group.js
// module id = V4lK
// module chunks = 5